<div class="modal modal-success">
  <div class="header-title">
    <mat-icon fontSet="material-icons-outlined">celebration</mat-icon>
    <h6 class="title-large">{{ "Success" | translate }}</h6>
  </div>
  <div class="subtitle">
    <span class="message"
      >{{
        "You have successfully completed all the required steps. Thank you."
          | translate
      }}
    </span>
  </div>
  <div class="modal-footer">
    <button mat-button="" [mat-dialog-close]="" class="btn-md btn-secondary">
      {{ "close" | translate }}
    </button>
  </div>
</div>
